import { render, staticRenderFns } from "./inBody.vue?vue&type=template&id=42d4e3a6&scoped=true"
import script from "./inBody.vue?vue&type=script&lang=ts"
export * from "./inBody.vue?vue&type=script&lang=ts"
import style0 from "./inBody.vue?vue&type=style&index=0&id=42d4e3a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d4e3a6",
  null
  
)

export default component.exports